import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useMetricOverview({
  enabled = true,
  category = '',
  from = '',
  to = '',
}: {
  enabled?: boolean;
  category: string;
  from?: string;
  to?: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['metrics/overview', category, from, to], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'metrics/overview',
        params: { category, from, to },
      });
      return res;
    },
    enabled,
    retry: false,
  });
}
